export function popitup(url,windowName) {
  let newwindow=window.open(url,windowName,'height=800,width=720');
  if (window.focus) {newwindow.focus()}
  return false;
}